<template>
    <base-tooltip
        class="inline"
        :close-after="5000"
    >
        <template slot="tooltip">
            {{ title }}
        </template>

        <div
            slot="trigger"
            class="border-b border-dotted cursor-pointer border-grey-darker"
        >
            <slot />
        </div>
    </base-tooltip>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            }
        }
    }
</script>
